import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import {ReportConfig} from "../../../@types";
import ReportTaskBurnDown_Settings from "./settings";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";

export default class ReportTaskBurnDown extends Report<ReportTaskBurnDown_Settings> {

    static reportName   : string = "Burndown"

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_TASK_BURN_DOWN
        super(data);

        this.icon         = "isvg-burndown"
        this.description  = "Tracks remaining work over time, showing the rate of task completion and helping determine if the project is on track to meet deadlines."

        this.settings     = new ReportTaskBurnDown_Settings(data.settings)
    }

    static initFromSavedView(savedView: SavedView): ReportTaskBurnDown {
        return new ReportTaskBurnDown(savedView.toReportConfig());
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportTaskBurnDown_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

    applyProjectScope(projectId: ID) {
        super.applyProjectScope(projectId)

        this.settings.projectId = projectId
    }

    save(){
        console.log("Not implemented")
    }
}
